<template>
    <div class="accountRateFlowersForm">
        <!-- Rate arrangement form -->
        <div class="flex items-center justify-between input">
            <p v-text="$t('RATE_FLOWERS_FORM_FLAWLESS')"></p>
            <label class="inputSwitch">
                <input type="checkbox" v-model="form.flawlesslyDelivered">
                <span class="inputSwitch__slider inputSwitch__slider--round"></span>
            </label>
        </div>

        <!--Delivery issues text box-->
        <div class="accordion accordion__sm accordion__sm--no-scroll"
             :class="{'accordion__sm--active' : !form.flawlesslyDelivered}">
            <div class="input">
                <label for="delivery-issue-summary" class="input__label"
                    v-text="$t('RATE_FLOWERS_FORM_CAN_YOU_TELL')"></label>
                <textarea
                    rows="4"
                    id="delivery-issue-summary"
                    v-model="form.deliveryIssueSummary"
                    class="input__textarea">
                </textarea>
            </div>
        </div>

        <!--Star ratings-->
        <p class="mt-10 px-3" v-text="$t('RATE_FLOWERS_FORM_AND_WHEN')"></p>

        <!--Quality-->
        <div class="input">
            <star-rating-field
                :label="$t('RATE_FLOWERS_FORM_LABEL_QUALITY')"
                :max-stars="5"
                v-model="form.quality">
            </star-rating-field>
            <p class="input__message" v-if="$v.form.quality.$error"
                v-text="$t('RATE_FLOWERS_FORM_PLEASE_SELECT_QUALITY')"></p>
        </div>

        <div class="input">
            <star-rating-field
                :label="$t('RATE_FLOWERS_FORM_LABEL_STYLE')"
                :max-stars="5"
                v-model="form.style">
            </star-rating-field>
            <p class="input__message" v-if="$v.form.style.$error"
                v-text="$t('RATE_FLOWERS_FORM_PLEASE_SELECT_STYLE')"></p>
        </div>

        <div class="input">
            <star-rating-field
                :label="$t('RATE_FLOWERS_FORM_LABEL_VALUE')"
                :max-stars="5"
                v-model="form.value">
            </star-rating-field>
            <p class="input__message" v-if="$v.form.value.$error"
                v-text="$t('RATE_FLOWERS_FORM_PLEASE_SELECT_VALUE')"></p>
        </div>

        <!--Other Comments-->
        <div class="input">
            <label for="comments" class="input__label" v-text="$t('RATE_FLOWERS_FORM_COMMENTS')"></label>
            <textarea
                rows="4"
                id="comments"
                v-model="form.comments"
                class="input__textarea">
            </textarea>
        </div>

        <!--Errors-->
        <div class="w-full p-2" v-if="errorHandler.getAllErrors()">
            <ul class="error list-disc text-center">
                <li v-for="(errorMsg, key) in errorHandler.getAllErrors()" :key="key">
                    <span class="font-bold capitalize" v-text="key"></span>:
                    <span class="font-normal" v-text="$t(errorMsg)"></span>
                </li>
            </ul>
        </div>

        <!--Actions-->
        <div class="text-center">
            <button
                class="btn btn--primary mt-4"
                @click="validateStep"
                :disabled="isFormProcessing" v-text="$t('RATE_FLOWERS_FORM_FEEDBACK')"></button>
        </div>

        <!--Success modal-->
        <rated-arrangement-modal
            v-if="showSuccessModal"
            @closed="showSuccessModal = false"
            :total-rating="totalRating">
        </rated-arrangement-modal>
    </div>
</template>

<script>
import between from 'vuelidate/src/validators/between';
import required from 'vuelidate/src/validators/required';
import CmsService from '@/services/cms/CmsService';
import ErrorResponseHandler from '@/helpers/ErrorResponseHandler';
import StarRatingField from '@/components/forms/fields/StarRatingField';
import RatedArrangementModal from '@/components/modals/RatedArrangementModal';

export default {
    name: 'RateFlowersForm',
    data() {
        return {
            form: {
                flawlesslyDelivered: true,
                deliveryIssueSummary: null,
                quality: null,
                style: null,
                value: null,
                comments: null,
            },
            isFormProcessing: false,
            errorHandler: new ErrorResponseHandler(),
            showSuccessModal: false,
        };
    },
    props: {
        orderId: {
            required: true,
            type: Number,
        },
    },
    validations: {
        form: {
            quality: {
                required: required,
                between: between(1, 5),
            },
            style: {
                required: required,
                between: between(1, 5),
            },
            value: {
                required: required,
                between: between(1, 5),
            },
        },
    },
    methods: {
        forceRequiredValidationMessagesVisibility() {
            this.form.quality = (this.form.quality !== null) ? this.form.quality : 0;

            this.form.style = (this.form.style !== null) ? this.form.style : 0;

            this.form.value = (this.form.value !== null) ? this.form.value : 0;
        },

        toggleFormProcessing() {
            this.isFormProcessing = !this.isFormProcessing;
        },

        submit() {
            let cmsService = new CmsService();

            cmsService.rateArrangementForOrder(
                this.orderId, {
                    quality: this.form.quality,
                    style: this.form.style,
                    value: this.form.value,
                    comments: this.form.comments,
                    deliveryIssues: !this.form.flawlesslyDelivered,
                    deliveryComments: this.form.deliveryIssueSummary,
                })
                .then(() => {
                    this.showSuccessModal = true;
                })
                .catch(error => this.errorHandler.setResponse(error.response.data));
        },

        validateStep() {
            this.toggleFormProcessing();
            this.$v.$touch();

            this.areAllFormFieldsValid ? this.submit() : this.forceRequiredValidationMessagesVisibility();

            this.toggleFormProcessing();
        },
    },
    computed: {
        areAllFormFieldsValid() {
            return !this.$v.$invalid;
        },

        totalRating() {
            return this.form.quality + this.form.style + this.form.value;
        },
    },
    components: {
        StarRatingField,
        RatedArrangementModal,
    },
};
</script>
